import { TiGroup } from 'react-icons/ti';
import { GoTelescope } from 'react-icons/go';
import { GiObservatory } from 'react-icons/gi';
import { FaUserAstronaut } from 'react-icons/fa';
import { WiMoonAltNew } from 'react-icons/wi';
import { MdForum } from 'react-icons/md';

export const cards = [
  {
    key: 1,
    icon: TiGroup,
    heading: 'A welcoming community of astronomy enthusiasts',
    text: 'Joining the club is a great way to meet new people that share your interests in all areas of science and astronomy. Whether your interest is in just learning the night sky, or going into deep levels of details about particle physcis, this is the place for you.',
  },
  {
    key: 2,
    icon: GoTelescope,
    heading: 'Borrow books & gear from our inventory',
    text: "Not sure what you want to get? After three months of membership, you're eligible to check out a telescope from our club library. We also have dozens of books and various pieces of astronomical equipment MdEventAvailable.",
  },
  {
    key: 3,
    icon: GiObservatory,
    heading: 'Unlock Cheddar Ranch Observatory',
    text: "Cheddar Ranch Observatory is our private observatory outside of OKC. It's a relaxing, fun place with a dark sky. After three months, you're eligible for a CRO membership to go whenever you want, not just on our Member Nights.",
  },
  {
    key: 4,
    icon: MdForum,
    heading: 'Members-only Facebook & forum discussion groups',
    text: "Don't want to wait until a club meeting to talk to someone? We have members-only areas of our Forum and a private Facebook group so there's always someone to virtually hang out with.",
  },
  {
    key: 5,
    icon: FaUserAstronaut,
    heading: 'No registration deadline for the Okie-Tex Star Party',
    text: 'If not a member, not pre-registering and showing up at the door of Okie-Tex is an increased fee. As an OKCAC member, you can just show up to Okie-Tex whenever you want and pay the same as if you had pre-registered.',
  },
  {
    key: 6,
    icon: WiMoonAltNew,
    heading: 'Membership into the Astronomical League',
    text: 'We are a member of the Astronomical League, and by joining our club, you are too! The primary benefit of being an AL member is a subscription to The Reflector magazine.',
  },
];
